// A rectangle on screen (ADR-026; contracts section 12). Perception returns one for a located target
// and the surface's HostBridge.host.locate resolves to one, so it lives here rather than in either.
// Finite numbers (zod rejects NaN and Infinity); a width or height is never negative.
import { z } from "zod";
import { strictObject } from "./primitives.js";
export const Rect = strictObject({
    x: z.number(),
    y: z.number(),
    width: z.number().nonnegative(),
    height: z.number().nonnegative(),
});
//# sourceMappingURL=rect.js.map